import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import LoginForm from './LoginForm';
import { useLogin, useAuthPreflight } from '../../services/authentication';
import { useTranslation } from 'react-i18next';

function LoginFormContainer() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [step, setStep] = useState('email');
  const [ssoError, setSsoError] = useState('');
  const [{ isLoading, error }, signIn, resetLoginError] = useLogin();
  const [preflightRes, checkAuthFlow] = useAuthPreflight();

  const errKey = searchParams.get('errKey');
  const appName = searchParams.get('appName');

  const initialError = errKey && t(`auth.errors.${errKey}`, {appName: appName || 'the url'});

  useEffect(() => {
    if (!preflightRes.isSuccess || !preflightRes.data) return;
    const { authFlow, identityProviderName, allowedSubdomains } = preflightRes.data;
    if (authFlow === 'SSO' && identityProviderName) {
      const currentRedirectUrl = searchParams.get('redirectUrl');
      const resolvedRedirectUrl = currentRedirectUrl ||
        (allowedSubdomains?.[0] ? `https://${allowedSubdomains[0]}.insight-rx.com/loginSaml` : null);
      if (!resolvedRedirectUrl) {
        setSsoError(t('auth.errors.ssoNoRedirectUrl'));
        return;
      }
      window.location.replace(`/api/v1/sso/redirect/${identityProviderName}?redirectUrl=${encodeURIComponent(resolvedRedirectUrl)}`);
    } else {
      setStep('password');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [preflightRes.isSuccess, preflightRes.data]); // intentional: full object would fire on isLoading changes

  function handleBack() {
    setStep('email');
    setPassword('');
    setSsoError('');
    resetLoginError();
  }

  return (
    <LoginForm
      username={username}
      setUsername={setUsername}
      password={password}
      setPassword={setPassword}
      step={step}
      onEmailSubmit={() => { setSsoError(''); checkAuthFlow({ login: username }); }}
      onFormSubmit={() => signIn({ login: username, password })}
      onBack={handleBack}
      isSubmitting={isLoading || preflightRes.isLoading}
      formError={initialError || ssoError || error || preflightRes.error}
    />
  );
}

export default LoginFormContainer;
